import {
  CartLinesRemovePayload,
  CartLinesUpdatePayload,
  CartLineUpdateInput,
  CartLineInput,
  CartLinesAddPayload,
  CartAttributesUpdatePayload,
  AttributeInput,
} from '@shopify/hydrogen-react/storefront-api-types';
import {
  REMOVE_CART_ITEMS,
  UPDATE_CART_ITEMS,
  ADD_CART_ITEMS,
  CART_ATTRIBUTES_UPDATE,
} from './queries';
import { executeGraphQLQuery } from '../storefrontClient';

export const addCartItems = async (
  cartId: string,
  lineItems: CartLineInput[]
): Promise<CartLinesAddPayload | undefined> => {
  try {
    const response = await executeGraphQLQuery(ADD_CART_ITEMS, {
      cartId,
      lineItems,
    });
    return Promise.resolve(response.data.cartLinesAdd);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateCartItems = async (
  cartId: string,
  lineItems: CartLineUpdateInput[]
): Promise<CartLinesUpdatePayload | undefined> => {
  try {
    const response = await executeGraphQLQuery(UPDATE_CART_ITEMS, {
      cartId,
      lineItems,
    });
    return Promise.resolve(response.data.cartLinesUpdate);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const removeCartItems = async (
  cartId: string,
  lineIds: string[]
): Promise<CartLinesRemovePayload | undefined> => {
  try {
    const response = await executeGraphQLQuery(REMOVE_CART_ITEMS, {
      cartId,
      lineIds,
    });
    return Promise.resolve(response.data.cartLinesRemove);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const cartAttributesUpdate = async (
  cartId: string,
  attributes: AttributeInput[]
): Promise<CartAttributesUpdatePayload | undefined> => {
  try {
    const response = await executeGraphQLQuery(CART_ATTRIBUTES_UPDATE, {
      cartId,
      attributes,
    });
    return Promise.resolve(response.data.cartAttributesUpdate);
  } catch (error) {
    return Promise.reject(error);
  }
};
